import { COURSE_OVERVIEW_URL_FRAGMENT, LESSONS_URL_FRAGMENT, LESSON_OVERVIEW_URL_FRAGMENT, TRACKS_URL_FRAGMENT } from '../../constants/Navigation';
import { getPlaylistUrl } from '../../utils/RoutingUtils';
import { getShortContentUrl } from '../shortContent';
export const getLearningContentItemUrl = ({
  id,
  type,
  language
}) => {
  switch (type) {
    case 'TRACK':
      return {
        url: `${TRACKS_URL_FRAGMENT}/${id}`,
        overviewUrl: `${COURSE_OVERVIEW_URL_FRAGMENT}/${id}${language ? `/${language}` : null}`
      };
    case 'LESSON':
      return {
        url: `${LESSONS_URL_FRAGMENT}/${id}`,
        overviewUrl: `${LESSON_OVERVIEW_URL_FRAGMENT}/${id}${language ? `/${language}` : null}`
      };
    case 'PLAYLIST':
      return {
        url: getPlaylistUrl(id)
      };
    case 'SHORT_FORM_CONTENT':
      if (language) return {
        url: getShortContentUrl({
          shortId: id,
          language
        })
      };
      break;
    default:
      return {};
  }
  return {};
};